import { useTranslation } from 'react-i18next';
import { Header } from '@widgets';
import ComposeIcon from '@assets/icons/messages/compose.svg';

interface MessagesHeaderProps {
  threadId: string;
  onDelete: (value: boolean) => void;
  onEditor: (value: boolean) => void;
}

export const MessagesHeader = (props: MessagesHeaderProps) => {
  const { t } = useTranslation('messages');

  return (
    <Header
      className='hidden max-[840px]:[display:inherit]'
      action={
        <div className='flex'>
          {props.threadId && (
            <div
              className='text-[#bdbdbd] cursor-pointer font-sans text-sm font-medium h-15 leading-15 tracking-[0.2px] px-5 normal-case whitespace-nowrap'
              onClick={() => props.onDelete(true)}
            >
              {t('buttons.delete', { ns: 'common' })}
            </div>
          )}
          <div
            className='text-[#bdbdbd] cursor-pointer font-sans text-sm font-medium h-15 leading-15 tracking-[0.2px] px-5 normal-case whitespace-nowrap max-[840px]:flex max-[840px]:items-center'
            onClick={() => props.onEditor(true)}
          >
            {t(`buttons.${props.threadId ? 'reply' : 'new'}`, { ns: 'common' })}
            <ComposeIcon className='ml-1.5 relative top-0.5' />
          </div>
        </div>
      }
    >
      <div>{t('header.title')}</div>
    </Header>
  );
};
